import { render, staticRenderFns } from "./PageModeratorBookChapterChapterStepEdit.vue?vue&type=template&id=78486c9e&"
import script from "./PageModeratorBookChapterChapterStepEdit.vue?vue&type=script&lang=js&"
export * from "./PageModeratorBookChapterChapterStepEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
